<template>
    <div class="content">

        <sub-title
            title="荣誉资质"
            class="title"
        ></sub-title>

        <div class="list">
            <div
                v-for="(item,index) in data"
                :key="index"
                class="item_img"
            > <img :src="item" /></div>

        </div>
    </div>
</template>

<script>
import SubTitle from '../../index/component/sub-title.vue';
export default {
    components: { SubTitle },
    data() {
        return {
            data: [
                '/images/about/h_01.png',
                '/images/about/h_02.png',
                '/images/about/h_03.png',
                '/images/about/h_04.jpg',
                '/images/about/h_05.jpg',
                '/images/about/h_06.jpg',
                '/images/about/h_07.jpg',
            ],
        };
    },
    mounted() {},
    methods: {},
};
</script>
<style lang='scss' scoped>
.content {
    width: 1250px;
    padding: 95px 20px 82px;
    background: #fff;

    .title {
        margin-bottom: 93px;
    }
    .list {
        display: flex;
        justify-content: space-between;
        .item_img {
            width: 163px;
            height: 122px;
            display: flex;
            justify-content: center;
            background-image: linear-gradient(#f2faff, #fff);
            box-shadow: 0 1px 4px rgba(0, 0, 0, 0.27);
            padding: 2px 0px;
            transition: all 0.3s;

            &:hover {
                transform: scale(1.3);
            }

            img {
                height: 118px;
                cursor: pointer;
            }
        }
    }
}
</style>
